import React, { useEffect, useState } from "react";
import { Box, Stack, useTheme } from "@mui/material";
import { APP_MAX_WIDTH } from "../constants/layout";

const AppWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
    const theme = useTheme();

    useEffect(() => {
        // Update viewport height on resize to handle Safari issues
        const handleResize = () => setViewportHeight(window.innerHeight);
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <Stack
            className="force-dynamic-translation"
            direction="column"
            width="100%"
            height={`${viewportHeight}px`} // Dynamic viewport height
            justifyContent="center"
            alignItems="center"
            bgcolor={theme.palette.primary.main}
            sx={{
                backgroundImage:
                    'url("https://www.transparenttextures.com/patterns/cartographer.png")',
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    maxWidth: APP_MAX_WIDTH, // 💡 or 640/768 depending on your visual preference
                    height: "100%", // full height inside the centered box
                    backgroundColor: "background.default", // inherits MUI theme
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {children}
            </Box>{" "}
        </Stack>
    );
};

export default AppWrapper;
